module.exports = new __parcel__URL__("ct-ch4-monthgrid-v2023-cover.9fbfa765.jpg").toString();